import { T as t } from "./Textfield-BfqxzX1d.js";
import { d as m } from "./define-element-Dl91r6Vu.js";
m("sp-textfield", t);
//# sourceMappingURL=sp-textfield-DUJtyE8s.js.map
